import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { PATIENT_HISTORY_KEY } from '../constants';
import { getPatientHistory } from '@modules/genetic-counseling/services';
import { PatientHistory } from '../types';

const useQueryPatientHistory = <TError = unknown>(
  { onError, onSettled, onSuccess, id }: any,
  options?: Omit<
    UseQueryOptions<PatientHistory[] | undefined, TError, PatientHistory[] | undefined, Array<string | undefined>>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<PatientHistory[] | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  const onSuccessFn = (data: PatientHistory[] | undefined): void => {
    onSuccess?.(data);
  };

  const onErrorFn = (err: unknown): void => {
    onError?.(err);
  };

  const onSettledFn = (_data: PatientHistory[] | undefined, _error: unknown): void => {
    onSettled?.();
  };

  return useQuery([PATIENT_HISTORY_KEY, id], async () => await getPatientHistory({ id }), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
    onError: onErrorFn,
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
    retry: 2,
  });
};

export default useQueryPatientHistory;
